import { ReportBI } from '../services';
import { withoutDefaults } from '../util';
import {
  cairoDataExtensionUnsuccessfulUpdateInServer,
  cairoModalCtaClicked,
  cairoTryAgainClicked,
} from '@wix/bex-utils/@wix/bi-logger-os-data/v2';
import { CustomFieldForm } from './CustomFieldModalState';
import { formatPermissionsForBi } from './formatPermissionsForBi';

export interface FieldOperationsBIReporterParams {
  reportBi: ReportBI;
}

export class FieldOperationsBIReporter {
  readonly reportBi: ReportBI;

  constructor(params: Readonly<FieldOperationsBIReporterParams>) {
    const { reportBi } = params;

    this.reportBi = reportBi;
  }

  reportArchiveFieldModalCtaClicked = (ctaName: string) => {
    this.reportBi(
      withoutDefaults(cairoModalCtaClicked)({
        ctaName,
        modalName: 'Archive custom field',
      }),
    );
  };

  reportDeleteFieldModalCtaClicked = (ctaName: string) => {
    this.reportBi(
      withoutDefaults(cairoModalCtaClicked)({
        ctaName,
        modalName: 'Delete custom field',
      }),
    );
  };

  reportArchiveFieldFailed = ({
    origin,
    formValues,
  }: {
    origin: string;
    formValues?: CustomFieldForm;
  }) => {
    if (!formValues) {
      return;
    }

    this.reportBi(
      withoutDefaults(cairoDataExtensionUnsuccessfulUpdateInServer)({
        actionName: 'Archive',
        errorType: 'Technical issue',
        origin,
        permissions: formatPermissionsForBi(formValues),
        fieldType: formValues.type,
        fieldName: formValues.name,
        key: formValues.key,
      }),
    );
  };

  reportArchiveTryAgain = () => {
    this.reportBi(
      withoutDefaults(cairoTryAgainClicked)({
        actionName: 'Archive custom field',
        loaction: 'toast',
      }),
    );
  };

  reportRestoreFieldFailed = ({
    origin,
    formValues,
  }: {
    origin: string;
    formValues?: CustomFieldForm;
  }) => {
    if (!formValues) {
      return;
    }

    this.reportBi(
      withoutDefaults(cairoDataExtensionUnsuccessfulUpdateInServer)({
        actionName: 'Restore',
        errorType: 'Technical issue',
        origin,
        permissions: formatPermissionsForBi(formValues),
        fieldType: formValues.type,
        fieldName: formValues.name,
        key: formValues.key,
      }),
    );
  };

  reportRestoreTryAgain = () => {
    this.reportBi(
      withoutDefaults(cairoTryAgainClicked)({
        actionName: 'Restore custom field',
        loaction: 'toast',
      }),
    );
  };
}
